import { ENUM_MODAL, STATUS_REQUERIMENTO } from 'utils/consts';
import { fetchVerificarReatendimento } from 'store/fetchActions/fetchFormulario';
import { fetchStatusModal } from 'store/fetchActions/fetchApp';
import { primeiraLetraPalavraUpperCase } from 'utils/funcaoPadrao';

export const getMensagemDia = () => {
  const data = new Date();
  const hora = data.getHours();
  if (hora >= 0 && hora < 12) return 'Bom dia';
  else if (hora >= 12 && hora < 18) return 'Boa tarde';
  else return 'Boa noite';
};

export const buscarListaReatendimento = (modalState, atendenteId) => dispatch => {
  if (modalState?.title !== ENUM_MODAL.LISTA_REATENDIMENTO) {
    dispatch(fetchVerificarReatendimento(atendenteId)).then(retorno => {
      if (retorno?.length > 0) {
        dispatch(fetchStatusModal(true, ENUM_MODAL.LISTA_REATENDIMENTO));
      }
    });
  }
};

export const montarArrayCard = (dadosCard, isSetorial) => {
  const array = [];
  const statusCard = isSetorial ? STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE : STATUS_REQUERIMENTO.ABERTO;
  Object.keys(dadosCard).forEach(key => {
    const novoObjeto = statusCard;
    novoObjeto.valor = dadosCard[key];
    array.push(novoObjeto);
  });
  return array;
};

export const getDescricaoCard = (quantidade, isSetorial) => {
  return isSetorial
    ? `Existem ${quantidade} Requerimentos Encaminhados.`
    : `Existem ${quantidade} Requerimentos em Aberto.`;
};

export const descricaoAtendente = nomeUsuario =>
  `${primeiraLetraPalavraUpperCase(nomeUsuario)} é o responsável pelo atendimento das requisições, ` +
  `garantindo o suporte necessário ao contribuinte. Todas as requisições ` +
  `atribuídas ao seu perfil ficam disponíveis na página de listar, localizado ` +
  `no menu superior do sistema.`;

export const descricaoIniciarAtendimento = `Para iniciar um novo atendimento, clique no botão abaixo`;
